module.exports = __webpack_public_path__ + "img/personal-portfolio-landing.4f993c4f.png";